'use strict'

define [], () ->
  (RentappService, $state) ->
    restrict: "E"
    template: require("./rspSignupPrompts.jade")
    link: (scope, element, attrs) ->
      scope.display_alert_states = [
        'root.dashboard.applications', 
        'root.dashboard.forms'
      ]

      RentappService.getMe().then (user) ->
        scope.sources_needed_to_active = {}
        for rsp in user.report_source_profiles
          if !rsp.active
            if ['smartmove_core', 'smartmove_plus', 'experian_credit'].indexOf(rsp.source_identifier) >= 0 && _.size(scope.rowCollection) == 0
                continue
            scope.sources_needed_to_active[rsp.vendor_name] = scope.sources_needed_to_active[rsp.vendor_name] or []
            scope.sources_needed_to_active[rsp.vendor_name].push rsp
      
      scope.$watch(() ->
        $state.$current.name
      , (newVal, oldVal) ->
        scope.current_state = $state.$current.name
        if scope.current_state in scope.display_alert_states
          scope.alert_active = true
        else
          scope.alert_active = false
      )



// WEBPACK FOOTER //
// ./directives/rspSignupPrompts/rspSignupPrompts.coffee